const SMPQuestDefaultStrategy = require("@/quest-editor/questImpl/strategies/SMPQuestDefaultStrategy");
class SMPQuestMakeNHeroReviveStrategy extends SMPQuestDefaultStrategy {

     initStartingValue() {
          this._challengeList = [2, 3, 5, 8];
     }

     increaseKPIGameplayReference() {
          this.questContext.KPIGameplayBossLevel += this.questContext.JumpingLevel;
     }

     computeChallenge() {
          this.questContext.challengeTarget = this.getTargetBaseOnLevel(this.questContext.level);
     }

     computeLevelShouldAppear() {
          let shouldAppearAt = this.questContext.challengeTarget * 50;
          shouldAppearAt = Math.max(1, this.questContext.KPIGameplayBossLevel - shouldAppearAt);
          if (shouldAppearAt < 1) shouldAppearAt = 1;
          this.questContext.KPIGameLevelShouldAppear = shouldAppearAt;
     }
}

module.exports = SMPQuestMakeNHeroReviveStrategy;